import { render, staticRenderFns } from "./certificado.vue?vue&type=template&id=f018d19c&scoped=true&"
import script from "./certificado.vue?vue&type=script&lang=js&"
export * from "./certificado.vue?vue&type=script&lang=js&"
import style0 from "./certificado.vue?vue&type=style&index=0&id=f018d19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018d19c",
  null
  
)

export default component.exports